import { render, staticRenderFns } from "./SolicitacoesRelatorios.vue?vue&type=template&id=88eb7748&"
import script from "./SolicitacoesRelatorios.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesRelatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports